import useIconColor from '../../hooks/useIconColor';

const Icon = () => {
  const { background } = useIconColor();
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 26 26' fill='none'>
      <rect width='26' height='26' rx='13' fill={background} />
      <mask id='mask0_1045_88' maskUnits='userSpaceOnUse' x='2' y='2' width='22' height='22'>
        <rect x='2' y='2' width='22' height='22' fill='white' />
      </mask>
      <g mask='url(#mask0_1045_88)'>
        <path
          d='M7.63931 16.6911C7.73831 16.5921 7.87031 16.5371 8.01331 16.5371H20.9493C21.1803 16.5371 21.3013 16.8231 21.1363 16.9881L18.5843 19.5401C18.4853 19.6391 18.3533 19.6941 18.2103 19.6941H5.26331C5.03231 19.6941 4.91131 19.4081 5.07631 19.2431L7.63931 16.6911Z'
          fill='#C931F7'
        />
        <path
          d='M7.63931 7.154C7.73831 7.055 7.87031 7 8.01331 7H20.9493C21.1803 7 21.3013 7.286 21.1363 7.451L18.5843 10.003C18.4853 10.102 18.3533 10.157 18.2103 10.157H5.26331C5.03231 10.157 4.91131 9.871 5.07631 9.706L7.63931 7.154Z'
          fill='#1CE2AF'
        />
        <path
          d='M18.5733 11.8952C18.4743 11.7962 18.3423 11.7412 18.1993 11.7412H5.26331C5.03231 11.7412 4.91131 12.0272 5.07631 12.1922L7.62831 14.7442C7.72731 14.8432 7.85931 14.8982 8.00231 14.8982H20.9383C21.1693 14.8982 21.2903 14.6122 21.1253 14.4472L18.5733 11.8952Z'
          fill='#6697CE'
        />
      </g>
    </svg>
  );
};

export default Icon;
